import { Navigate, Outlet } from 'react-router-dom';
import DashboardLayout from 'src/components/layouts/dashboard/DashboardLayout';
import MainLayout from 'src/components/layouts/main/MainLayout';
import Account from 'src/pages/Account';
import EmployeeList from 'src/components/pages/vaccination/employee/EmployeeList';
import Dashboard from 'src/components/pages/vaccination/dashboard/Dashboard';
import Reports from 'src/pages/Reports';
import Login from 'src/pages/Login';
import NotFound from 'src/pages/NotFound';
import AhcEmployees from 'src/components/pages/ahc/ahcEmployees/AhcEmployees';
import AhcDashboard from 'src/components/pages/ahc/ahcDashboard/AhcDashboard';
import AhcRepository from './components/pages/ahc/Repository/ahcRepository';
import CreateAppointment from './components/pages/ahc/CreateAppointment/AhcCreateAppointment';
import CreateAppointmentEmployees from './components/pages/ahc/CreateAppointment/CreateAppointmentEmployees';
import AhcCYE from './components/pages/ahc/cye/cye';
import AhcMISEmployees from './components/pages/ahc/ahcMisData/AhcMISEmployees';
// import AhcPHSDashboard from './components/pages/ahc/phsDashboard/Dashboard'
import GoldDashboard from 'src/components/pages/gold/dashboard/GoldDashboard';
import GoldEmployees from 'src/components/pages/gold/employees/GoldEmployees';
import MedicineDashboard from './components/pages/medicine/MedicineDashboard';
import MedicineProvider from './components/pages/medicine/ProviderWise';
import MedicineUtilization from './components/pages/medicine/MedicineUtilization';
import TrackOrder from './components/pages/medicine/TrackOrder';
import MedicineMIS from './components/pages/medicine/MedicineMIS';
import MaternityEmployees from './components/pages/maternity/employees/MaternityEmployees';
import MaternityDashboard from './components/pages/maternity/dashboard/MaternityDashboard';
import EntityCreation from './components/pages/ahcOnbaroding/EntityCreation';
import PackageCreation from './components/pages/ahcOnbaroding/PackageCreation';
import PackageCart from './components/pages/ahcOnbaroding/PackageCart';
import EmployeeAddition from './components/pages/ahcOnbaroding/EmployeeAddition';
import NestedList from './components/pages/ahcOnbaroding/PackageInfo';
import PackageProperty from './components/pages/ahcOnbaroding/PacakgeProperty';
import WalletConfiguration from './components/pages/ahcOnbaroding/WalletConfiguration';
import clevertap from 'clevertap-web-sdk';
import WalletDashboard from './components/pages/Wallet/Dashboard';
import PhsInvoice from './components/pages/ahc/ahcMisData/PhsInvoicedData';
import PhsMisData from './components/pages/ahc/ahcMisData/phsMisData';
import EligiblePackages from './components/pages/ahc/eligiblePackages/eligiblePackages';
import ReimbursementMain from './components/pages/reimbursement/reimbursementToDo/ReimbursementMain';
import ViewDocs from './components/pages/viewDocs/ViewDocsMain';
import ReimbursementViewClaimDetails from './components/pages/reimbursement/reimbursementToDo/ReimbursementViewClaimDetails';
import CashlessMain from './components/pages/cashless/CashlessMain';
import { AffinityMis } from './components/pages/affinity';
// import Register from 'src/pages/Register';
import { services, subServices } from './models/sideBar';
import OnsiteRepository from './components/pages/onsite/repository';
import SupersetDashboard from './components/pages/superset/dashboard';
import UserBenefCreation from 'src/components/pages/dataManagement/UserBenefCreation';
import UserUpdationInactivation from 'src/components/pages/dataManagement/UserUpdationInactivation';
import BenefUpdationInactivation from 'src/components/pages/dataManagement/BenefUpdationInactivation';
import PHSLeaderboard from './components/pages/ahc/phsleaderboard/PHSLeaderboard';
import HealthTrendsDashboard from './components/pages/healthTrends/dashboard';
const routes = (isLoggedIn, isMinor) => {
  const url =
    isLoggedIn && isLoggedIn.service && isLoggedIn.service[0]
      ? services[isLoggedIn.service[0]].redirectUrl
      : '/app/ahc/employees';
  let event = `hrwin`;
  let page = url.split('/');
  if (!page[3]) {
    if (page[2] === 'employees') {
      event = `Landed on vaccination employees on HRWIN`;
    } else {
      event = `Landed on vaccination dashboard on HRWIN`;
    }
  } else {
    event = `Landed on ${page[2]} ${page[3]} on HRWIN`;
  }
  console.log(event);
  clevertap.event.push(event);
  return [
    {
      path: 'app',
      element: isLoggedIn ? <DashboardLayout /> : <Navigate to="/login" />,
      children: [
        { path: 'account', element: <Account /> },
        {
          path: 'employees',
          element: !isMinor ? <EmployeeList /> : <Navigate to="/login" />,
          children: [{ path: ':statusId*', element: <EmployeeList /> }]
        },
        { path: 'dashboard', element: <Dashboard /> },
        { path: 'reports', element: <Reports /> },
        { path: 'ahc/employees', element: <AhcEmployees /> },
        { path: 'ahc/dashboard', element: <AhcDashboard /> },
        { path: 'ahc/repository', element: <AhcRepository /> },
        { path: 'ahc/createAppointment', element: <CreateAppointment /> },
        { path: 'ahc/createAppointmentBookings', element: <CreateAppointmentEmployees /> },
        { path: 'ahc/phsinvoice', element: <PhsInvoice /> },
        { path: 'ahc/eligibility', element: <EligiblePackages /> },
        { path: 'ahc/phsmis', element: <PhsMisData /> },
        { path: 'ahc/cye', element: <AhcCYE /> },
        { path: 'ahc/mis', element: <AhcMISEmployees /> },
        { path: 'ahc/phsleaderboard', element: <PHSLeaderboard /> },
        { path: 'gold/dashboard', element: <GoldDashboard /> },
        { path: 'gold/employees', element: <GoldEmployees /> },
        { path: 'medicine/dashboard', element: <MedicineDashboard /> },
        { path: 'medicine/providerwise', element: <MedicineProvider /> },
        { path: 'medicine/utilization', element: <MedicineUtilization /> },
        { path: 'medicine/trackOrder', element: <TrackOrder /> },
        { path: 'medicine/mis', element: <MedicineMIS /> },
        { path: 'maternity/employees', element: <MaternityEmployees /> },
        { path: 'maternity/dashboard', element: <MaternityDashboard /> },
        { path: 'ahcOnboarding/EntityCreation', element: <EntityCreation /> },
        { path: 'ahcOnboarding/PackageCreation', element: <PackageCreation /> },
        { path: 'ahcOnboarding/PackageCart', element: <PackageCart /> },
        { path: 'ahcOnboarding/EmployeeAddition', element: <EmployeeAddition /> },
        { path: 'ahcOnboarding/PackageProperty', element: <PackageProperty /> },
        { path: 'ahcOnboarding/WalletConfiguration', element: <WalletConfiguration /> },
        { path: 'wallet/dashboard', element: <WalletDashboard /> },
        { path: 'insurer/reimbursement', element: <ReimbursementMain /> },
        { path: 'insurer/viewDocs', element: <ViewDocs /> },
        { path: 'insurer/reimbursement/claimDetails/:empId/:claimId', element: <ReimbursementViewClaimDetails /> },
        { path: 'insurer/cashless', element: <CashlessMain /> },
        { path: 'affinity/mis', element: <AffinityMis /> },
        { path: 'onsite/repository', element: <OnsiteRepository /> },
        { path: 'data-management/user-benef-creation', element: <UserBenefCreation /> },
        { path: 'data-management/user-updation', element: <UserUpdationInactivation /> },
        { path: 'data-management/benef-updation', element: <BenefUpdationInactivation /> },
        { path: 'superset/eyoc', element: <SupersetDashboard /> },
        { path: 'superset/tcsbelowforty', element: <SupersetDashboard /> },
        { path: 'superset/Utilization', element: <SupersetDashboard /> },
        { path: 'superset/NestleBusinessServices', element: <SupersetDashboard /> },
        { path: 'superset/NestleIndiaLimited', element: <SupersetDashboard /> },
        { path: 'superset/Airtel', element: <SupersetDashboard /> },
        { path: 'superset/OPDCorpUtilization', element: <SupersetDashboard /> },
        { path: 'superset/Utilization', element: <SupersetDashboard /> },
        { path: 'superset/CAR', element: <SupersetDashboard /> },
        { path: 'superset/OPDCorpRIUtilization', element: <SupersetDashboard /> },
        { path: 'superset/OPDMAUtilization', element: <SupersetDashboard /> },
        { path: 'superset/GOLDUtilization', element: <SupersetDashboard /> },
        { path: 'superset/CorpHealthReport', element: <SupersetDashboard/>},
        {
          path: 'health-trends/dashboard',
          element:
            isLoggedIn &&
            isLoggedIn.subservices &&
            isLoggedIn.subservices.includes('HealthTrends - Dashboard') ? (
              <HealthTrendsDashboard />
            ) : (
              <Navigate to="/404" />
            )
        },
        { path: '*', element: <Navigate to="/404" /> }
      ]
    },
    {
      path: '/',
      element: <MainLayout />,
      children: [
        {
          path: 'login',
          element: isLoggedIn ? <Navigate to={url} /> : <Login />
        },
        // { path: 'register', element: <Register /> },
        { path: '404', element: <NotFound /> },
        {
          path: '/',
          element: isLoggedIn ? <Navigate to={url} /> : <Navigate to="/login" />
        },
        { path: '*', element: <Navigate to="/404" /> }
      ]
    }
  ];
};

export default routes;
